const getLastPageNumber = (itemsCount: number, pageSize: number) =>
  itemsCount < pageSize ? 0 : Math.ceil(itemsCount / pageSize);

export default getLastPageNumber;
